// src/index.tsx
import { Box, Button, Fade, Text } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var cookieTextStyles = {
  a: {
    textDecoration: "underline",
    color: "greyscale.600",
    cursor: "pointer"
  }
};
var animationVariants = {
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: "easeOut"
    }
  },
  enter: {
    opacity: 1,
    transition: {
      duration: 0.1,
      ease: "easeIn"
    }
  }
};
var CookiesNotice = ({
  hideNotice,
  buttonText,
  htmlText,
  onClick,
  ...props
}) => /* @__PURE__ */ jsxs(Box, {
  as: Fade,
  in: !hideNotice,
  variants: animationVariants,
  unmountOnExit: true,
  zIndex: 999,
  position: "fixed",
  display: { base: "inline", md: "inline-grid" },
  boxShadow: "alt",
  bg: "white",
  borderRadius: { base: "none", md: "md" },
  w: { base: "100%", md: "311px" },
  right: { md: 4 },
  bottom: { base: 0, md: "70px" },
  py: { base: 4, md: "8" },
  px: 6,
  boxSizing: "border-box",
  "data-testid": "cookiesNotice",
  ...props,
  children: [
    /* @__PURE__ */ jsx(Text, {
      fontSize: "md",
      color: "greyscale.600",
      mb: { base: 0, md: 5 },
      mr: { base: 3, md: 0 },
      sx: cookieTextStyles,
      dangerouslySetInnerHTML: {
        __html: htmlText
      },
      as: "span"
    }),
    /* @__PURE__ */ jsx(Button, {
      title: buttonText,
      variant: "linkPrimary",
      bg: "transparent",
      border: "none",
      color: "primary.500",
      _focus: { boxShadow: "none" },
      _hover: { md: { color: "primary.600" } },
      fontWeight: "semibold",
      justifyContent: "left",
      onClick,
      cursor: "pointer",
      fontFamily: "Lab Grotesque",
      "data-testid": "cookiesNoticeButton",
      pl: 0,
      children: buttonText
    })
  ]
});
export {
  CookiesNotice
};
